import { render, staticRenderFns } from "./ServiceManagement.vue?vue&type=template&id=0791da10&"
import script from "./ServiceManagement.vue?vue&type=script&lang=js&"
export * from "./ServiceManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports